export default __webpack_public_path__ + "static/media/barcode.d1f566c9.svg";